/**
 * Map Module
 *
 * Interactive map visualization using Google Maps JavaScript API.
 * Engagement-focused: animated markers, glassmorphism panel, smooth interactions.
 * Reusable across showcases, properties, and fleet via the generic MapItem interface.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const mapModule: AppModule = {
    id: 'map',

    navigation: {
        label: 'Map',
        icon: 'map',
        path: '/showcases/map',
        order: 18,
        moduleKey: 'showcases',
        showInSidebar: false,


        pages: [
            {
                label: 'Map',
                path: '/showcases/map',
                icon: 'map',
            },
            {
                label: 'Settings',
                path: '/showcases/map/settings',
                icon: 'settings',
            },
        ],
    },

    routes,
}

export default mapModule
